const loaderDiv: HTMLElement = document.createElement('div');
const body: HTMLElement = document.body;

let loadersCount = 0;
let loadersEnabled = true;

export function showLoader() {
    if (!loadersEnabled) {
        return;
    }

    loadersCount++;
    loaderDiv.classList.add('loader-container');
    loaderDiv.setAttribute('id', 'loader');
    body.appendChild(loaderDiv);
    setTimeout(() => {
        if (loadersCount > 0) {
            loaderDiv.classList.add('visible');
        }
    }, 100);
}

export function hideLoader() {
    if (!loadersEnabled) {
        return;
    }

    loadersCount--;
    const loader: HTMLElement | null = document.getElementById('loader');
    if (!loader || loadersCount > 0) {
        return;
    }

    loader.classList.remove('visible');

    setTimeout(() => {
        if (loader.parentNode) {
            loader.parentNode.removeChild(loader);
        }
    }, 1000);
}

export function showLoaderAsync(promise: Promise<any>): Promise<any> {
    showLoader();
    return promise.finally(() => {
        hideLoader();
    });
}

export function disableLoaders() {
    loadersEnabled = false;
}

export function enableLoaders() {
    loadersEnabled = true;
}
